import React, { useState, useEffect, useRef } from "react";
import Tooltip from "./Tooltip";
import Select from "./Select";
import SaveButtons from "./SaveButtons";
import { getCurrency } from "../../utils/helper";

const options = ["Current", "1 Month", "3 Months", "6 Months", "1 Year", "All"];

const DefaultValues = ({ data, handleUpdate, settings }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [properties, setProperties] = useState([]);
  const [showSave, setShowSave] = useState(false);
  const inputRefs = useRef([]);

  const dropdownOptions = ["FBA", "FBM"];

  const handleChange = (e, idx) => {
    let value;

    const updatedProperties = [...properties];
    if (updatedProperties[idx].isToggle) {
      value = e?.target?.value;
    } else {
      value = e?.target?.value?.replace(/[^0-9.]/g, "");
    }

    updatedProperties[idx].value = value;
    setProperties(updatedProperties);
    setShowSave(true);
  };

  const handleChangeSelect = (e, idx) => {
    let value;

    const updatedProperties = [...properties];
    if (updatedProperties[idx].isToggle) {
      value = e;
    } else {
      value = e?.replace(/[^0-9.]/g, "");
    }

    updatedProperties[idx].value = value;
    setProperties(updatedProperties);
    setShowSave(true);
  };

  const handleSave = () => {
    let updatedData = properties.reduce((acc, property) => {
      if(property.property === "fba_inbound_placement_service" && !property.value) return acc;
      acc[property.property] = property?.title?.includes(getCurrency(settings.marketplace))
        ? parseFloat(property.value).toFixed(2) || "0.00"
        : property.value || "0";
      return acc;
    }, {});
    
    // update the data object
    data = { ...data, ...updatedData };
    handleUpdate(data);
    setShowSave(false);
  };

  const handleCancel = () => {
    setProperties(createPropertiesFromData(data));
    setShowSave(false);
  };

  useEffect(() => {
    setProperties(createPropertiesFromData(data));
  }, [data]);

  const createPropertiesFromData = (data) => {
    return [
      {
        title: "Ranks and Prices Time Frame",
        value: data?.ranksprices_timeframe || "1 Month",
        property: "ranksprices_timeframe",
        text: "Ranks and Prices Time Frame is the time frame you want to set for the product.",
        isToggle: true,
        type: "Ranks",
      },
      {
        title: "Buy Box Analysis Time Frame (days)",
        value: data?.bb_analysis_timeframe || "1 Month",
        property: "bb_analysis_timeframe",
        text: "Buy Box Analysis Time Frame is the time frame you want to set for the product.",
        isToggle: true,
        type: "BuyBox",
      },
      {
        title: "Chart Time Frame",
        value: data?.charts_timeframe || "1 Month",
        property: "charts_timeframe",
        text: "Buy Box Analysis Time Frame is the time frame you want to set for the product.",
        isToggle: true,
        type: "Chart",
      },
    ];
  };

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const handleFocus = (idx) => {
    const input = inputRefs.current[idx];
    const valueLength = properties[idx].value.length;
    input.setSelectionRange(valueLength, valueLength);
  };

  return (
    <div
      className="flex flex-col w-full border-primary bg-primary-bg p-4 mt-4 border border-border/100 rounded-2xl"
    >
      <div
        className="flex cursor-pointer items-center mb-2"
        onClick={toggleAccordion}
      >
        <div
          className="mr-1 text-primary font-bold"
          style={{
            fontSize: "16px",
          }}
        >
          Data Time Frames
        </div>
        <div>{/* {isOpen ? <FaAngleUp /> : <FaAngleDown />} */}</div>
      </div>
      {isOpen && (
        <>
          {properties.map((property, index) => (
            <div
              key={index}
              className={`${
                property?.isToggle ? "" : "flex"
              } text-white justify-between bg-secondary-dark p-4 rounded-lg align-center mb-2`}
              style={{
                fontSize: "13px",
              }}
            >
              <div
                className={`${
                  property?.isToggle ? "w-full" : "w-full"
                } flex items-center`}
                style={{ textAlign: "left" }}
              >
                <span
                  style={
                    {
                      // maxWidth: "68%"
                    }
                  }
                >
                  {property.title}
                </span>
                <Tooltip text={property.text} />
              </div>
              <div className="">
                {property.isToggle ? (
                  <Select
                    inputValue={options.includes(property?.value) ? property?.value : options[1]}
                    handleDropdownChange={(e) => handleChangeSelect(e, index)}
                    dropdownOptions={
                      property?.type === "Ranks"
                        ? ["Current", "1 Month", "3 Months", "6 Months", "1 Year", "All"]
                        : property?.type === "BuyBox"
                        ? ["1 Month", "3 Months", "6 Months", "1 Year", "All"]
                        : property?.type === "Chart"
                        ? ["1 Week", "1 Month", "3 Months", "6 Months", "1 Year", "All"]
                        : []
                    }
                  />
                ) : property.isToggle && property.type === "fulfillment" ? (
                  <Select
                    inputValue={property?.value}
                    handleDropdownChange={(e) => handleChangeSelect(e, index)}
                    dropdownOptions={dropdownOptions}
                  />
                ) : (
                  <input
                    type="text"
                    value={`${property.title.includes(getCurrency(settings.marketplace)) ? getCurrency(settings.marketplace) : ""}${
                      property?.value
                    }${property.title.includes("%") ? "%" : ""}`}
                    onChange={(e) => handleChange(e, index)}
                    onFocus={() => handleFocus(index)}
                    ref={(el) => (inputRefs.current[index] = el)}
                    placeholder={`${getCurrency(settings.marketplace)}20`}
                    className={`text-center text-white border border-primary rounded-xl bg-primary-dark max-w-[20vw]`}
                    style={{
                      borderRadius: "12px",
                    }}
                  />
                )}
              </div>
            </div>
          ))}
          {showSave && (
            <SaveButtons handleSave={handleSave} handleCancel={handleCancel} />
          )}
        </>
      )}
    </div>
  );
};

export default DefaultValues;
